import workspaceQuery from 'graphql/queries/nominal/NominalDimensionWorkspaceQuery.graphql';
import listQuery from 'graphql/queries/nominal/NominalDimensionListQuery.graphql';
import instanceQuery from 'graphql/queries/nominal/NominalDimensionQuery.graphql';
import defaultQuery from 'graphql/queries/nominal/NominalDimensionDefault.graphql';
import mutationQuery from 'graphql/mutations/nominal/NominalDimensionMutation.graphql';
import fragment from 'graphql/fragments/nominal/NominalDimensionFragment.graphql';

const Dimension = {
  type: 'Dimension',
  title: 'Nominal Dimensions',
  formTitle: 'Dimension',
  formUrl: '/Nominal/Dimension/Details/',
  workspaceUrl: '/Nominal/Dimension/Workspace/',
  instance: instanceQuery,
  workspace: workspaceQuery,
  default: defaultQuery,
  update: mutationQuery,
  list: listQuery,
  dropdown: {
    query: listQuery,
    valueKey: 'id',
    labelKey: 'title',
  },
  fragment,
  screenReference: 'NOMINAL_DIMENSIONS',
};

export default Dimension;
